// Author thq
// Date 2024-03-25 18:22:03

import * as model from "@/model/em/statusCollection/TpmTsdOpcConfigTtcModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.TpmTsdOpcConfigTtc(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_EM_STATUSCOLLECTION_URL,
    })
    .buildStore()
